import {
  Box,
  CssBaseline,
  Grid,
  ThemeProvider,
  createTheme,
} from "@mui/material";
// import Footer from "components/Footer";
import React from "react";
import Logo from "../components/Logo";
// import { ToastContainer } from "react-toastify";

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
});

function saveMode(mode: "light" | "dark") {
  localStorage.setItem("colorMode", mode);
}

function loadMode() {
  return localStorage.getItem("colorMode") === "dark" ? "dark" : "light";
}

export default function LayoutMode({ children }: any) {
  // const [mode, setMode] = React.useState<"light" | "dark">(loadMode());
  const [mode, setMode] = React.useState<"light" | "dark">("dark");

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const newMode = prevMode === "light" ? "dark" : "light";
          saveMode(newMode);
          return newMode;
        });
      },
    }),
    []
  );

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          background: {
            default: mode === "light" ? "#fff" : "transparent",
          },
        },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                // borderRadius: 16,
                // overflow: "scroll",
                background: "rgba(30,30,30,1)",
              },
            },
          },
        },
        typography: {
          fontFamily: '"JetBrains Mono", monospace',
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            bgcolor: "background.default",
          }}
          component={"div"}
        >
          <Grid container spacing={10}>
            <Grid
              size={{
                xs: 12,
              }}
            >
              <Logo />
            </Grid>
            <Grid size={{ xs: 12 }}>{children}</Grid>
            {/* <Grid item xs={12}>
              <Footer />
            </Grid> */}
          </Grid>
        </Box>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
